export enum PaymentMethods {
  CREDIT_CARD = 'credit_card',
  DEBIT_CARD = 'debit_card',
  CHEQUE = 'cheque',
  NETBANKING = 'netbanking'
}
